module.exports = __webpack_public_path__ + "img/cate2.6a1ae46c.png";